import React, { createContext, useState, useEffect, JSX } from "react";
import { User } from "../types/features/User";
import { authService } from "../services/authService";
import useToken from "../hooks/features/auth/useToken";

interface AuthContextType {
  user: User | null;
  // 1. On ajoute setUser au type du contexte
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  loading: boolean;
  error: any | null;
  refreshUser: () => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any | null>(null);
  const { token, saveToken , izilifeToken } = useToken();

  const fetchUser = async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const currentUser = await authService.getCurrentUser(token , izilifeToken);
      setUser(currentUser);
    } catch (err) {
      setError(err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [token]);

  const logout = () => {
    setUser(null);
    saveToken(null);
  };

  return (
    // 2. On passe setUser dans la value du Provider
    <AuthContext.Provider value={{ user, setUser, loading, error, refreshUser: fetchUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
